import { Form } from 'antd';
import { type FormProviderProps } from 'antd/es/form/context';
import { useEffect } from 'react';

import { authActions } from '@store/auth/auth.slice';

import { useResetPasswordMutation } from '@hook/auth/auth.hooks';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreDispatch, useStoreSelector } from '@hook/store/store.hooks';

export const useForgotPassword = () => {
  const dispatch = useStoreDispatch();
  const [form] = Form.useForm();
  const { error, isLoading } = useStoreSelector((state) => state.auth);
  const { action, state } = useMutation(useResetPasswordMutation(), authActions);

  const onReset: FormProviderProps['onFormFinish'] = (_, { values }) =>
    action({
      email: values.email,
    });

  useEffect(() => () => void dispatch(authActions.resetErrors()), []);

  return {
    form,
    error,
    isLoading: isLoading || state.isLoading,
    isSent: state.isSuccess,
    onReset,
  };
};
